import { render, staticRenderFns } from "./BpcFooter.vue?vue&type=template&id=1f140f29&"
import script from "./BpcFooter.vue?vue&type=script&lang=js&"
export * from "./BpcFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports